/* ==========================================================================
   Silver Sakhi – shopping assistant, Gift Finder and order help
   Config: <script id="AssistantConfig"> in sections/assistant.liquid
   Uses window.STJ (theme.js) for product cards, money and toasts.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('AssistantConfig');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var T = window.theme || { routes: {}, settings: {} };
  var STJ = window.STJ || {};
  var root = (T.routes.root || '/').replace(/\/?$/, '/');
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var TEXT = C.text || {};
  var LAST_KEY = 'stj_gf_last';
  var CAT_KEY = 'stj_gf_catalog_v1';
  var GENDERS = ['women', 'men', 'kids'];

  /* ---------- Small helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function list(str) {
    return String(str || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }
  function rupees(n) {
    return STJ.formatMoney ? STJ.formatMoney(Math.round(n * 100)).replace(/\.00$/, '') : '₹' + Math.round(n).toLocaleString('en-IN');
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function waLink(text, number) {
    var n = number === undefined ? C.whatsapp : number;
    return 'https://wa.me/' + (n || '') + '?text=' + encodeURIComponent(text);
  }
  function trackLink(awb) {
    return (C.trackingUrl || '').replace('{number}', encodeURIComponent(String(awb).trim()));
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- Line icons (24px grid, stroke = currentColor) ---------- */
  var ICONS = {
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    rings: '<circle cx="9" cy="14.5" r="5"/><circle cx="15" cy="14.5" r="5"/><path d="M9 9.5 7.4 7.5 9 5.5l1.6 2z"/>',
    flower: '<path d="M12 20c-4 0-7-3-7-6.5 2 0 4 1 5 2.5M12 20c4 0 7-3 7-6.5-2 0-4 1-5 2.5M12 20c-2-2-3-4.5-3-7s1.2-5 3-7c1.8 2 3 4.5 3 7s-1 5-3 7z"/>',
    users: '<circle cx="9" cy="8" r="3"/><path d="M3 19.5c0-3.3 2.7-6 6-6s6 2.7 6 6"/><circle cx="17" cy="9" r="2.4"/><path d="M16.5 13.6c2.6.4 4.5 2.7 4.5 5.4"/>',
    user: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7"/>',
    'user-tie': '<circle cx="12" cy="7.5" r="3.5"/><path d="M5 20.5c0-3.9 3.1-7 7-7s7 3.1 7 7"/><path d="m12 13.5-1 1.8 1 4.2 1-4.2z"/>',
    child: '<circle cx="12" cy="6" r="2.5"/><path d="M8 11.5c1.2-1.3 2.5-2 4-2s2.8.7 4 2M12 9.5V15M9.5 20.5 12 15l2.5 5.5M8.5 12.5 7 14.5M15.5 12.5l1.5 2"/>',
    star: '<path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8-4.3-4.1 5.9-.9z"/>',
    sparkle: '<path d="m12 3 1.8 5.4L19 10l-5.2 1.6L12 17l-1.8-5.4L5 10l5.2-1.6zM19 15l.7 1.8 1.8.7-1.8.7L19 20l-.7-1.8-1.8-.7 1.8-.7z"/>',
    gift: '<rect x="3.5" y="8.5" width="17" height="4" rx=".5"/><path d="M5 12.5V20h14v-7.5M12 8.5V20M12 8.5C10.5 5.5 7 5 7 7.3 7 8.5 9.5 8.5 12 8.5zm0 0c1.5-3 5-3.5 5-1.2 0 1.2-2.5 1.2-5 1.2z"/>',
    cake: '<rect x="4" y="12" width="16" height="8" rx="1"/><path d="M4 16c2 0 2-1.5 4-1.5s2 1.5 4 1.5 2-1.5 4-1.5 2 1.5 4 1.5M8 12V9.5M12 12V9.5M16 12V9.5M8 6.5v.5M12 6.5v.5M16 6.5v.5"/>',
    crown: '<path d="M4 19h16M5 19 4 9l4.5 3.5L12 6l3.5 6.5L20 9l-1 10"/>',
    diya: '<path d="M3.5 13h17c0 3.3-3.8 6-8.5 6s-8.5-2.7-8.5-6zM12 4c1.5 2 2 3.2 2 4.4a2 2 0 0 1-4 0C10 7.2 10.5 6 12 4z"/>',
    moon: '<path d="M19 14.5A7.5 7.5 0 0 1 9.5 5a7.5 7.5 0 1 0 9.5 9.5z"/>',
    bow: '<circle cx="12" cy="12" r="2.3"/><path d="M9.8 11.2C7.2 8.5 3.5 8.6 3.5 12s3.7 3.5 6.3.8M14.2 11.2c2.6-2.7 6.3-2.6 6.3.8s-3.7 3.5-6.3.8M10.6 14 8.5 20M13.4 14l2.1 6"/>',
    baby: '<circle cx="12" cy="12" r="7"/><path d="M9.6 11.5h.01M14.4 11.5h.01M10.3 14.8c1 .7 2.4.7 3.4 0M12 5c0-1 .8-1.6 1.7-1.4"/>',
    ring: '<circle cx="12" cy="14.5" r="5.5"/><path d="M9.6 6.5 12 4l2.4 2.5L12 9z"/>',
    earring: '<path d="M12 3a2.5 2.5 0 0 1 2.5 2.5c0 1.6-2.5 2.2-2.5 4.2"/><circle cx="12" cy="11" r="1"/><path d="M12 12.5c2 2.6 3 4.2 3 5.5a3 3 0 0 1-6 0c0-1.3 1-2.9 3-5.5z"/>',
    pendant: '<path d="M4 4c1.5 5 4.5 8 8 8s6.5-3 8-8M12 12v1.5M12 13.5l3 3-3 4-3-4z"/>',
    chain: '<path d="M9.5 14.5l5-5M8 11l-2 2a3 3 0 0 0 4.2 4.2l2-2M16 13l2-2a3 3 0 0 0-4.2-4.2l-2 2"/>',
    bracelet: '<ellipse cx="12" cy="11" rx="8" ry="5"/><circle cx="8" cy="15.6" r="1.3"/><circle cx="12" cy="16.2" r="1.3"/><circle cx="16" cy="15.6" r="1.3"/>',
    anklet: '<path d="M3 8c2.5 4 5.5 6 9 6s6.5-2 9-6M7 13.2v1.6M12 14v2M17 13.2v1.6"/><circle cx="7" cy="16" r="1.1"/><circle cx="12" cy="17.2" r="1.1"/><circle cx="17" cy="16" r="1.1"/>',
    kada: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="5.5"/>',
    necklace: '<path d="M4.5 4c0 7 3.4 11 7.5 11s7.5-4 7.5-11"/><circle cx="12" cy="17.5" r="2.2"/>',
    coin: '<circle cx="12" cy="12" r="8.5"/><path d="M9.5 8.5h5M9.5 11h5M11 8.5c2.6 0 2.6 5 0 5H9.5l4 3"/>',
    leaf: '<path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14zM5 19l7.5-7.5"/>',
    diamond: '<path d="M6.5 4h11L21 9l-9 11L3 9zM3 9h18M9.5 4 8 9l4 11 4-11-1.5-5"/>',
    contrast: '<circle cx="12" cy="12" r="8"/><path d="M12 4a8 8 0 0 0 0 16z" fill="currentColor" stroke="none"/>',
    ruler: '<path d="M3 16.5 16.5 3 21 7.5 7.5 21zM7 12.5l2 2M10 9.5l2 2M13 6.5l2 2"/>',
    exchange: '<path d="M4 9h14l-3.5-3.5M20 15H6l3.5 3.5"/>',
    'map-pin': '<path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>',
    award: '<circle cx="12" cy="9" r="5.5"/><path d="M8.6 13.4 7 21l5-2.5 5 2.5-1.6-7.6"/>',
    box: '<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5zM3.5 7.5 12 12l8.5-4.5M12 12v9"/>',
    truck: '<path d="M2.5 6h11v10h-11zM13.5 9.5h4l3 3.5v3h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    trend: '<path d="m3 17 6-6 4 4 8-8M15 7h6v6"/>',
    chat: '<path d="M4 5h16v11H9.5L4 20z"/>',
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>',
    receipt: '<path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6"/>',
    history: '<path d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4M12 8v4l3 2"/>',
    refresh: '<path d="M20 11a8 8 0 0 0-14.6-4M4 13a8 8 0 0 0 14.6 4M5 3v4h4M19 21v-4h-4"/>',
    phone: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z"/>',
    whatsapp: '<path d="M4 20l1.2-3.8A8 8 0 1 1 8 19z"/><path d="M9 9.5c.3 2.3 2.2 4.2 4.5 4.5l1-1.2 1.8.7-.4 1.7c-3.6.2-7.3-3.4-7.1-7.1l1.7-.4.7 1.8z" fill="currentColor" stroke="none"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>'
  };
  function icon(name, size) {
    if (!name || !ICONS[name]) return '';
    size = size || 18;
    return '<svg class="sa-ic" viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[name] + '</svg>';
  }

  /* ---------- Options from the blocks ---------- */
  var OPT = { person: [], occasion: [], jewellery: [], style: [], budget: [], answer: [] };
  (C.options || []).forEach(function (o) {
    if (!OPT[o.type] || !o.label) return;
    o.tagList = list(o.tags);
    OPT[o.type].push(o);
  });
  OPT.budget.forEach(function (b) { b.min = Number(b.min) || 0; b.max = Number(b.max) || 0; });
  function find(type, key) {
    for (var i = 0; i < OPT[type].length; i++) if (OPT[type][i].key === key) return OPT[type][i];
    return null;
  }
  var exclude = (C.exclude || []).map(function (t) { return String(t).trim(); }).filter(Boolean);

  /* ---------- Steps ---------- */
  var STEPS = [
    { id: 'p', type: 'person', q: TEXT.q1 || 'Who is the gift for?' },
    { id: 'o', type: 'occasion', q: TEXT.q2 || "What's the occasion?", skip: true },
    { id: 't', type: 'jewellery', q: TEXT.q3 || 'What would you like to gift?', multi: true },
    { id: 's', type: 'style', q: TEXT.q4 || 'Which style suits them best?', skip: true },
    { id: 'b', type: 'budget', q: TEXT.q5 || 'And your budget?' }
  ].filter(function (s) { return OPT[s.type].length; });

  function optionsFor(step, answers) {
    var opts = OPT[step.type];
    if (step.type === 'jewellery') {
      var person = find('person', answers.p);
      var g = person && person.gender;
      if (g && g !== 'any') opts = opts.filter(function (o) { return o[g] !== false; });
    }
    return opts;
  }

  /* Answers <-> "p:mother;o:diwali;t:rings,earrings;s:traditional;b:under-1-999" */
  function encode(a) {
    var parts = [];
    ['p', 'o', 's', 'b'].forEach(function (k) { if (a[k]) parts.push(k + ':' + a[k]); });
    if (a.t && a.t.length) parts.push('t:' + a.t.join(','));
    return parts.join(';');
  }
  function decode(str) {
    var a = { t: [] };
    String(str || '').split(';').forEach(function (part) {
      var i = part.indexOf(':');
      if (i < 1) return;
      var k = part.slice(0, i);
      var v = part.slice(i + 1);
      if (k === 't') a.t = v.split(',').filter(function (x) { return find('jewellery', x); });
      else if (k === 'p' && find('person', v)) a.p = v;
      else if (k === 'o' && find('occasion', v)) a.o = v;
      else if (k === 's' && find('style', v)) a.s = v;
      else if (k === 'b' && find('budget', v)) a.b = v;
    });
    return a;
  }
  function shareUrl(a) {
    var base = C.giftPageUrl ? location.origin + C.giftPageUrl : location.origin + location.pathname;
    return base + '?gf=' + encodeURIComponent(encode(a));
  }
  function summary(a) {
    var out = [];
    var o = find('occasion', a.o); if (o) out.push(o.label);
    if (a.t && a.t.length) out.push(a.t.map(function (k) { return find('jewellery', k).label; }).join(', '));
    var s = find('style', a.s); if (s) out.push(s.label);
    var b = find('budget', a.b); if (b) out.push(b.label);
    return out;
  }
  function headline(a) {
    var p = find('person', a.p);
    if (!p) return 'Gifts they’ll love';
    if (p.key === 'myself') return 'Picked just for you';
    return 'Gifts for your ' + p.label.replace(/\s*\/.*$/, '');
  }

  /* ---------- Catalog (all products, light fields only) ---------- */
  var catalogPromise;
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    try {
      var cached = JSON.parse(sessionStorage.getItem(CAT_KEY) || 'null');
      if (cached && Date.now() - cached.t < 20 * 60 * 1000) return (catalogPromise = Promise.resolve(cached.items));
    } catch (e) {}
    var items = [];
    function page(n) {
      return fetch(root + 'collections/all/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          (data.products || []).forEach(function (p) {
            var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
            tags = tags.map(function (t) { return String(t).trim().toLowerCase(); });
            var type = String(p.product_type || '').trim().toLowerCase().replace(/\s+/g, '-');
            if (/gift-?card/.test(type) || exclude.some(function (x) { return tags.indexOf(x) > -1; })) return;
            var prices = [], avail = false;
            (p.variants || []).forEach(function (v) {
              if (v.available) { avail = true; prices.push(Number(v.price)); }
            });
            if (!prices.length) prices = (p.variants || []).map(function (v) { return Number(v.price); });
            var img = p.images && p.images[0] ? p.images[0].src : '';
            items.push({
              h: p.handle,
              n: p.title,
              g: tags,
              y: type,
              p: prices.length ? Math.min.apply(null, prices) : 0,
              a: avail,
              d: Date.parse(p.published_at || p.created_at) || 0,
              i: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''
            });
          });
          if ((data.products || []).length === 250 && n < 12) return page(n + 1);
        });
    }
    catalogPromise = page(1).then(function () {
      try { sessionStorage.setItem(CAT_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
      return items;
    }).catch(function () { catalogPromise = null; return items; });
    return catalogPromise;
  }

  /* ---------- Matching ---------- */
  function hasAny(item, tags) {
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      if (item.g.indexOf(tags[i]) > -1 || item.y === tags[i]) return true;
    }
    return false;
  }
  function rank(items, a) {
    var person = find('person', a.p);
    var gender = person && person.gender !== 'any' ? person.gender : '';
    var occ = find('occasion', a.o);
    var sty = find('style', a.s);
    var bud = find('budget', a.b);
    var types = (a.t || []).map(function (k) { return find('jewellery', k); }).filter(Boolean);
    var typeTags = [];
    types.forEach(function (t) { typeTags = typeTags.concat(t.tagList); });

    // Hard filters: budget and gender
    var pool = items.filter(function (it) {
      if (bud) {
        if (it.p < bud.min) return false;
        if (bud.max && it.p > bud.max) return false;
      }
      if (gender) {
        var pg = it.g.filter(function (t) { return GENDERS.indexOf(t) > -1 || t === 'unisex'; });
        if (pg.length && pg.indexOf(gender) < 0 && pg.indexOf('unisex') < 0) return false;
      }
      return true;
    });
    // Style only filters once the catalog has products tagged for it; occasion only ranks
    var useOcc = occ && occ.tagList.length;
    var useSty = sty && sty.tagList.length && pool.some(function (it) { return hasAny(it, sty.tagList); });

    var perfect = [], more = [];
    pool.forEach(function (it) {
      var s = 0, ok = true;
      if (typeTags.length) { if (hasAny(it, typeTags)) s += 40; else ok = false; }
      if (gender && it.g.indexOf(gender) > -1) s += 20;
      if (useSty) { if (hasAny(it, sty.tagList)) s += 15; else ok = false; }
      if (useOcc && hasAny(it, occ.tagList)) s += 12;
      if (person && hasAny(it, person.tagList)) s += 8;
      if (it.g.indexOf('bestseller') > -1) s += 6;
      if (it.g.indexOf('new') > -1) s += 3;
      if (bud && bud.max) s += Math.min(it.p / bud.max, 1) * 8; // closer to the budget = richer gift
      if (!it.a) s -= 100;
      it.s = s;
      (ok ? perfect : more).push(it);
    });
    var byScore = function (x, y) { return y.s - x.s || y.d - x.d; };
    perfect.sort(byScore);
    more.sort(byScore);
    var picks = perfect.filter(function (it) { return it.a && it.g.indexOf('bestseller') > -1; });
    if (picks.length < 4) picks = perfect.filter(function (it) { return it.a; });
    return { perfect: perfect, more: more, picks: picks.slice(0, 8) };
  }
  function sortList(arr, how) {
    var copy = arr.slice();
    if (how === 'price-asc') copy.sort(function (x, y) { return (y.a - x.a) || x.p - y.p; });
    else if (how === 'price-desc') copy.sort(function (x, y) { return (y.a - x.a) || y.p - x.p; });
    else if (how === 'new') copy.sort(function (x, y) { return (y.a - x.a) || y.d - x.d; });
    return copy;
  }

  /* ---------- Product cards (same as the rest of the store) ---------- */
  var cardCache = {};
  function cards(handles) {
    var need = handles.filter(function (h) { return !(h in cardCache); });
    var job = need.length && STJ.fetchCards ? STJ.fetchCards(need) : Promise.resolve([]);
    return job.then(function (html) {
      need.forEach(function (h, i) { cardCache[h] = html[i] || ''; });
      return handles.map(function (h) { return cardCache[h]; });
    });
  }
  function skeletons(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<li class="gf-skel"><span></span><i></i><i></i></li>';
    return s;
  }

  /* ---------- Option tiles (chat and page) ---------- */
  function tilesHtml(step, answers, extraClass) {
    var chosen = step.multi ? (answers.t || []) : [answers[step.id]];
    var html = '<div class="gf-tiles gf-tiles--' + step.type + (extraClass ? ' ' + extraClass : '') + '" role="group" aria-label="' + esc(step.q) + '">';
    optionsFor(step, answers).forEach(function (o) {
      var on = chosen.indexOf(o.key) > -1;
      var media = o.image
        ? '<img src="' + esc(o.image) + '" alt="" loading="lazy" width="80" height="80">'
        : (ICONS[o.icon] ? icon(o.icon, 28) : '');
      html += '<button type="button" class="gf-tile' + (on ? ' is-on' : '') + (media ? '' : ' gf-tile--text') + '" data-gf-key="' + esc(o.key) + '" aria-pressed="' + on + '">' +
        (media ? '<span class="gf-tile__media">' + media + '</span>' : '') +
        '<span class="gf-tile__label">' + esc(o.label) + '</span></button>';
    });
    if (step.type === 'jewellery') {
      html += '<button type="button" class="gf-tile gf-tile--any' + (answers.t && answers.t.length === 0 && answers._tDone ? ' is-on' : '') + '" data-gf-key="__any">' +
        '<span class="gf-tile__media">' + icon('sparkle', 28) + '</span><span class="gf-tile__label">Suggest for me</span></button>';
    }
    return html + '</div>';
  }

  /* ---------- Results ---------- */
  function renderResults(host, answers, opts) {
    opts = opts || {};
    var a = JSON.parse(JSON.stringify(answers));
    var state = { sort: 'rec', shown: 0, list: [], perfectCount: 0 };
    var person = find('person', a.p);
    store(LAST_KEY, a);
    saveToCart(a);

    host.innerHTML =
      '<div class="gfr">' +
        '<div class="gfr__hero">' +
          '<p class="gfr__eyebrow">✦ ' + esc(TEXT.resultsEyebrow || 'Your personal gift edit') + '</p>' +
          '<h2 class="gfr__title">' + esc(headline(a)) + '</h2>' +
          '<p class="gfr__summary" data-gfr-summary></p>' +
          '<p class="gfr__count" data-gfr-count><span class="gf-dots"><i></i><i></i><i></i></span> Finding the best pieces…</p>' +
          '<div class="gfr__actions">' +
            '<a class="gfr__btn gfr__btn--wa" data-gfr-share target="_blank" rel="noopener">' + icon('whatsapp', 16) + ' Share with family</a>' +
            (C.whatsapp ? '<a class="gfr__btn" data-gfr-expert target="_blank" rel="noopener">' + icon('chat', 16) + ' Ask an expert</a>' : '') +
            '<button type="button" class="gfr__btn" data-gfr-restart>' + icon('refresh', 16) + ' Change answers</button>' +
          '</div>' +
        '</div>' +
        '<div class="gfr__bar">' +
          '<div class="gfr__chips" data-gfr-budget aria-label="Budget"></div>' +
          '<div class="gfr__chips" data-gfr-types aria-label="Jewellery type"></div>' +
          '<label class="gfr__sort">Sort <select class="select" data-gfr-sort>' +
            '<option value="rec">Recommended</option><option value="price-asc">Price: low to high</option>' +
            '<option value="price-desc">Price: high to low</option><option value="new">Newest</option></select></label>' +
        '</div>' +
        '<div class="gfr__picks" data-gfr-picks hidden><h3 class="gfr__h">' + icon('star', 20) + ' ' + esc(TEXT.picks || "Expert's picks") + '</h3><ul class="gfr__scroller" data-gfr-picks-list></ul></div>' +
        '<div data-gfr-perfect-wrap hidden><h3 class="gfr__h" data-gfr-perfect-h></h3><ul class="grid-products" data-gfr-perfect></ul></div>' +
        '<div data-gfr-more-wrap hidden><h3 class="gfr__h" data-gfr-more-h></h3><ul class="grid-products" data-gfr-more></ul></div>' +
        '<div class="gfr__empty" data-gfr-empty hidden></div>' +
        '<div class="gfr__loadmore"><button type="button" class="btn btn--outline" data-gfr-loadmore hidden>Show more designs</button><span data-gfr-sentinel></span></div>' +
        '<ul class="gfr__strip">' + (C.strip || []).map(function (s) { s = String(s).trim(); return s ? '<li>' + icon('check', 16) + ' ' + esc(s) + '</li>' : ''; }).join('') + '</ul>' +
      '</div>';

    var q = function (s) { return $(s, host); };
    var perfectUl = q('[data-gfr-perfect]'), moreUl = q('[data-gfr-more]');
    var loadBtn = q('[data-gfr-loadmore]');

    function paintChips() {
      q('[data-gfr-summary]').innerHTML = summary(a).map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('');
      q('[data-gfr-budget]').innerHTML = OPT.budget.map(function (b) {
        return '<button type="button" class="chip' + (a.b === b.key ? ' is-active' : '') + '" data-gfr-b="' + esc(b.key) + '">' + esc(b.label) + '</button>';
      }).join('');
      var typeStep = { type: 'jewellery' };
      q('[data-gfr-types]').innerHTML = '<button type="button" class="chip' + (!a.t.length ? ' is-active' : '') + '" data-gfr-t="__all">All jewellery</button>' +
        optionsFor(typeStep, a).map(function (o) {
          return '<button type="button" class="chip' + (a.t.indexOf(o.key) > -1 ? ' is-active' : '') + '" data-gfr-t="' + esc(o.key) + '">' + esc(o.label) + '</button>';
        }).join('');
      var share = 'Look at these silver gift ideas ' + (person && person.key !== 'myself' ? 'for ' + person.label.replace(/\s*\/.*$/, '') + ' ' : '') + '- ' + shareUrl(a);
      q('[data-gfr-share]').href = waLink(share, '');
      var exp = q('[data-gfr-expert]');
      if (exp) exp.href = waLink('Hi! I am looking for a gift' + (person ? ' for my ' + person.label : '') + '. ' + summary(a).join(' · ') + '. Can you suggest something?');
    }

    function run() {
      paintChips();
      if (opts.updateUrl && history.replaceState) {
        try { history.replaceState(null, '', location.pathname + '?gf=' + encodeURIComponent(encode(a))); } catch (e) {}
      }
      perfectUl.innerHTML = skeletons(8);
      q('[data-gfr-perfect-wrap]').hidden = false;
      q('[data-gfr-more-wrap]').hidden = true;
      q('[data-gfr-empty]').hidden = true;
      loadCatalog().then(function (items) {
        var r = rank(items, a);
        state.perfectCount = r.perfect.length;
        var perf = state.sort === 'rec' ? r.perfect : sortList(r.perfect, state.sort);
        var more = state.sort === 'rec' ? r.more : sortList(r.more, state.sort);
        state.list = perf.concat(more);
        state.shown = 0;
        var total = state.list.length;
        q('[data-gfr-count]').innerHTML = total
          ? 'We found <b>' + total + '</b> design' + (total === 1 ? '' : 's') + (r.perfect.length && r.more.length ? ' · <b>' + r.perfect.length + '</b> perfect matches' : '')
          : 'No designs found for this choice yet';
        q('[data-gfr-perfect-h]').textContent = (TEXT.perfect || 'Perfect match') + ' (' + r.perfect.length + ')';
        q('[data-gfr-more-h]').textContent = (r.perfect.length ? (TEXT.more || 'You may also love') : 'Closest matches') + ' (' + r.more.length + ')';
        q('[data-gfr-perfect-wrap]').hidden = !r.perfect.length;
        perfectUl.innerHTML = '';
        moreUl.innerHTML = '';
        // Expert's picks
        var picksWrap = q('[data-gfr-picks]');
        picksWrap.hidden = true;
        if (r.picks.length >= 3 && r.perfect.length > 8) {
          cards(r.picks.map(function (x) { return x.h; })).then(function (html) {
            var lis = html.filter(Boolean).map(function (c) { return '<li>' + c + '</li>'; }).join('');
            q('[data-gfr-picks-list]').innerHTML = lis;
            picksWrap.hidden = !lis;
            if (STJ.syncWishlistUI) STJ.syncWishlistUI();
          });
        }
        if (!total) {
          var empty = q('[data-gfr-empty]');
          empty.hidden = false;
          empty.innerHTML = '<p>We don’t have designs for this exact choice right now, but our team can help.</p>' +
            '<div class="gfr__actions">' +
            (a.b ? '<button type="button" class="gfr__btn" data-gfr-b="' + esc(OPT.budget[OPT.budget.length - 1].key) + '">Try another budget</button>' : '') +
            (a.t.length ? '<button type="button" class="gfr__btn" data-gfr-t="__all">Show all jewellery</button>' : '') +
            (C.whatsapp ? '<a class="gfr__btn gfr__btn--wa" target="_blank" rel="noopener" href="' + esc(waLink('Hi! I am looking for a gift. ' + summary(a).join(' · '))) + '">Ask on WhatsApp</a>' : '') +
            '</div>';
          q('[data-gfr-perfect-wrap]').hidden = true;
          loadBtn.hidden = true;
          return;
        }
        loadMore();
      });
    }

    var loading = false;
    function loadMore() {
      if (loading || state.shown >= state.list.length) return;
      loading = true;
      var batch = state.list.slice(state.shown, state.shown + (C.perPage || 24));
      var start = state.shown;
      state.shown += batch.length;
      var perfN = state.perfectCount;
      var inPerfect = batch.filter(function (x, i) { return start + i < perfN; });
      var inMore = batch.filter(function (x, i) { return start + i >= perfN; });
      if (inPerfect.length) perfectUl.insertAdjacentHTML('beforeend', '<li class="gf-skel-group" style="display:contents">' + skeletons(Math.min(inPerfect.length, 8)) + '</li>');
      if (inMore.length) { q('[data-gfr-more-wrap]').hidden = false; moreUl.insertAdjacentHTML('beforeend', '<li class="gf-skel-group" style="display:contents">' + skeletons(Math.min(inMore.length, 8)) + '</li>'); }
      loadBtn.hidden = true;
      cards(batch.map(function (x) { return x.h; })).then(function (html) {
        $$('.gf-skel-group', host).forEach(function (n) { n.remove(); });
        var pHtml = '', mHtml = '';
        html.forEach(function (c, i) {
          if (!c) return;
          if (start + i < perfN) pHtml += '<li class="gf-in">' + c + '</li>';
          else mHtml += '<li class="gf-in">' + c + '</li>';
        });
        perfectUl.insertAdjacentHTML('beforeend', pHtml);
        moreUl.insertAdjacentHTML('beforeend', mHtml);
        q('[data-gfr-more-wrap]').hidden = !moreUl.children.length;
        if (STJ.syncWishlistUI) STJ.syncWishlistUI();
        loading = false;
        var left = state.list.length - state.shown;
        loadBtn.hidden = left <= 0;
        loadBtn.textContent = 'Show more designs (' + left + ')';
      });
    }

    host.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gfr-b]');
      if (b) { a.b = b.getAttribute('data-gfr-b'); run(); return; }
      var t = e.target.closest('[data-gfr-t]');
      if (t) {
        var k = t.getAttribute('data-gfr-t');
        if (k === '__all') a.t = [];
        else {
          var i = a.t.indexOf(k);
          if (i > -1) a.t.splice(i, 1); else a.t.push(k);
        }
        run();
        return;
      }
      if (e.target.closest('[data-gfr-loadmore]')) { loadMore(); return; }
      if (e.target.closest('[data-gfr-restart]')) { if (opts.onRestart) opts.onRestart(a); }
    });
    q('[data-gfr-sort]').addEventListener('change', function (e) { state.sort = e.target.value; run(); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !loadBtn.hidden) loadMore();
      }, { rootMargin: '600px 0px' });
      io.observe(q('[data-gfr-sentinel]'));
    }
    run();
  }

  function saveToCart(a) {
    var p = find('person', a.p);
    var note = [p ? p.label : ''].concat(summary(a)).filter(Boolean).join(' · ');
    if (!note) return;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift Finder': note } })
    }).catch(function () {});
  }

  /* ---------- Results overlay ---------- */
  var overlay = $('[data-gf-overlay]');
  var overlayBody = overlay && $('[data-gf-overlay-body]', overlay);
  function openResults(a) {
    // On the Gift Finder page the results show inline
    var inline = $('[data-gf-page]');
    if (inline && inline._showResults) { closePanel(); inline._showResults(a); return; }
    if (!overlay) return;
    overlay.hidden = false;
    document.body.classList.add('gf-locked');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    overlayBody.scrollTop = 0;
    renderResults(overlayBody, a, {
      onRestart: function (cur) { closeResults(); openPanel('gift', { restart: true, preset: { o: cur.o } }); }
    });
  }
  function closeResults() {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('gf-locked');
    setTimeout(function () { overlay.hidden = true; }, 250);
  }
  if (overlay) {
    overlay.addEventListener('click', function (e) { if (e.target.closest('[data-gf-overlay-close]')) closeResults(); });
  }

  /* ==========================================================================
     Chat panel
     ========================================================================== */
  var wrap = $('[data-assistant]');
  var panel = $('#SaPanel');
  var body = panel && $('[data-sa-body]', panel);
  var form = panel && $('[data-sa-form]', panel);
  var input = panel && $('[data-sa-input]', panel);
  var toggleBtn = wrap && $('[data-sa-toggle]', wrap);
  var pendingInput = null;
  var started = false;
  var chain = Promise.resolve();

  function scrollDown() { if (body) body.scrollTop = body.scrollHeight; }
  function queue(fn) { chain = chain.then(fn).catch(function () {}); return chain; }

  function bot(html, delay) {
    return queue(function () {
      var typing = el('<div class="sa-msg sa-msg--bot sa-typing"><span class="gf-dots"><i></i><i></i><i></i></span></div>');
      body.appendChild(typing);
      scrollDown();
      return wait(delay == null ? 550 : delay).then(function () {
        typing.remove();
        var m = el('<div class="sa-msg sa-msg--bot">' + html + '</div>');
        body.appendChild(m);
        scrollDown();
        return m;
      });
    });
  }
  function block(node) {
    return queue(function () {
      var n = typeof node === 'string' ? el(node) : node;
      body.appendChild(n);
      scrollDown();
      return n;
    });
  }
  function user(text) {
    $$('.sa-quick', body).forEach(function (q) { q.remove(); });
    body.appendChild(el('<div class="sa-msg sa-msg--user">' + esc(text) + '</div>'));
    scrollDown();
  }
  /* Quick reply buttons: [{label, run}] */
  function quick(items) {
    return queue(function () {
      var row = el('<div class="sa-quick"></div>');
      items.forEach(function (it) {
        var b;
        if (it.href) {
          b = el('<a class="sa-chip" href="' + esc(it.href) + '"' + (it.external ? ' target="_blank" rel="noopener"' : '') + '>' + icon(it.icon, 16) + '<span>' + esc(it.label) + '</span></a>');
        } else {
          b = el('<button type="button" class="sa-chip">' + icon(it.icon, 16) + '<span>' + esc(it.label) + '</span></button>');
          b.addEventListener('click', function () { user(it.label); it.run(); });
        }
        row.appendChild(b);
      });
      body.appendChild(row);
      scrollDown();
      return row;
    });
  }

  function menuItems() {
    var items = [];
    var last = store(LAST_KEY);
    if (C.showGift && STEPS.length) items.push({ icon: 'gift', label: 'Find a gift', run: giftFlow });
    if (C.showOrder) items.push({ icon: 'box', label: 'Where is my order?', run: orderFlow });
    if (C.showGift && last && last.p) items.push({ icon: 'history', label: 'My last gift ideas', run: function () { openResults(last); } });
    OPT.answer.forEach(function (o) { items.push({ icon: o.icon, label: o.label, run: function () { answerFlow(o); } }); });
    if (C.showRate && dailyRate() > 0) items.push({ icon: 'trend', label: 'Today’s silver rate', run: rateFlow });
    if (C.showWhatsapp && C.whatsapp) items.push({ icon: 'whatsapp', label: 'Talk to our team', run: whatsappFlow });
    return items;
  }
  function menu(prompt) {
    bot(esc(prompt || C.menuPrompt || 'How can I help you today?'));
    quick(menuItems());
  }
  function anythingElse() {
    quick([{ icon: 'menu', label: 'Main menu', run: function () { menu('What else can I help you with?'); } }].concat(
      C.showWhatsapp && C.whatsapp ? [{ icon: 'whatsapp', label: 'Talk to our team', run: whatsappFlow }] : []
    ));
  }

  /* ---------- Name & mobile before the chat ---------- */
  var USER_KEY = 'stj_sa_user';
  var gate = false;
  function savedUser() {
    var u = store(USER_KEY);
    return u && u.phone ? u : null;
  }
  function firstName() {
    var u = savedUser();
    return (u && u.name ? u.name : C.firstName || '').split(' ')[0];
  }
  function needDetails() {
    if (C.askDetails === 'off' || savedUser()) return false;
    if (C.loggedIn && C.customerPhone) {
      store(USER_KEY, { name: C.customerName || C.firstName || '', phone: C.customerPhone });
      return false;
    }
    return true;
  }
  function cleanPhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return /^[6-9]\d{9}$/.test(d) ? d : '';
  }
  function sendLead(u) {
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Chat name': u.name, 'Chat mobile': '+91 ' + u.phone } })
    }).catch(function () {});
    if (!C.sendLeads || !C.shopEmail) return;
    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '\u2713');
    fd.append('contact[email]', C.shopEmail);
    fd.append('contact[name]', u.name);
    fd.append('contact[phone]', '+91 ' + u.phone);
    fd.append('contact[body]', 'New chat lead (' + (C.name || 'Assistant') + ')\nName: ' + u.name + '\nMobile: +91 ' + u.phone + '\nPage: ' + location.href);
    fetch(root + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
  }
  function askDetails(then) {
    gate = true;
    bot(esc(C.detailsText || 'Before we begin, may I have your name and mobile number?'), 400);
    var f = el('<form class="sa-details" novalidate>' +
      '<label class="sa-details__field"><span>Your name</span>' +
        '<input class="sa-details__in" name="name" autocomplete="name" maxlength="60" placeholder="Full name" value="' + esc(C.customerName || C.firstName || '') + '"></label>' +
      '<label class="sa-details__field"><span>Mobile number</span>' +
        '<span class="sa-details__phone"><b>+91</b><input class="sa-details__in" name="phone" type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="16" placeholder="10-digit mobile number"></span></label>' +
      '<p class="sa-details__err" role="alert" hidden></p>' +
      '<button type="submit" class="sa-details__btn">Continue ' + icon('check', 16) + '</button>' +
      (C.askDetails === 'optional' ? '<button type="button" class="sa-link sa-details__skip" data-skip>Skip for now</button>' : '') +
      '<p class="sa-details__note">' + icon('lock', 13) + ' Your details are safe with us. We never share them or send spam.</p>' +
    '</form>');
    var nameIn = $('input[name="name"]', f);
    var phoneIn = $('input[name="phone"]', f);
    block(f).then(function () {
      var first = nameIn.value ? phoneIn : nameIn;
      if (first && window.matchMedia('(min-width: 750px)').matches) first.focus();
    });
    function done(u) {
      gate = false;
      f.remove();
      if (u) user(u.name + ' · +91 ' + u.phone.replace(/(\d{5})(\d{5})/, '$1 $2'));
      then(u);
    }
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = nameIn.value.trim().replace(/\s+/g, ' ');
      var phone = cleanPhone(phoneIn.value);
      var err = $('.sa-details__err', f);
      err.hidden = true;
      if (name.length < 2) { err.textContent = 'Please enter your name.'; err.hidden = false; nameIn.focus(); return; }
      if (!phone) { err.textContent = 'Please enter a valid 10-digit mobile number.'; err.hidden = false; phoneIn.focus(); return; }
      var u = { name: name, phone: phone };
      store(USER_KEY, u);
      sendLead(u);
      done(u);
    });
    var skip = $('[data-skip]', f);
    if (skip) skip.addEventListener('click', function () { done(null); });
  }
  function withDetails(fn) {
    if (needDetails()) askDetails(function (u) {
      if (u) bot('Thank you, ' + esc(u.name.split(' ')[0]) + '.', 300);
      fn();
    });
    else fn();
  }

  function greet() {
    started = true;
    var hello = C.greeting || 'Namaste!';
    var fn = firstName();
    if (fn) hello = hello.replace(/^Namaste\b/i, 'Namaste ' + fn);
    bot(esc(hello).replace(/\n/g, '<br>'), 350);
    withDetails(function () { menu(); });
  }

  /* ---------- Gift flow (chat) ---------- */
  function giftFlow(preset) {
    var a = { t: [] };
    if (preset) Object.keys(preset).forEach(function (k) { if (preset[k]) a[k] = preset[k]; });
    var openers = ['Lovely, let’s find something special.', 'That’s thoughtful of you.', 'Great choice!', 'Almost there…', 'Last one!'];
    var i = 0;
    function next() {
      while (i < STEPS.length && STEPS[i].id === 'o' && a.o) i++;
      if (i >= STEPS.length) return finish();
      var step = STEPS[i];
      bot('<span class="sa-small">' + esc(openers[Math.min(i, openers.length - 1)]) + '</span><br><b>' + esc(step.q) + '</b>' +
        (step.multi ? '<br><span class="sa-small">Choose one or more</span>' : ''));
      var holder = el('<div class="sa-tiles">' + tilesHtml(step, a, 'gf-tiles--chat') +
        '<div class="sa-tiles__foot">' +
          (step.skip ? '<button type="button" class="sa-link" data-gf-skip>Skip</button>' : '') +
          (step.multi ? '<button type="button" class="sa-next" data-gf-next disabled>Continue →</button>' : '') +
        '</div></div>');
      block(holder);
      holder.addEventListener('click', function (e) {
        if (holder.classList.contains('is-done')) return;
        var tile = e.target.closest('[data-gf-key]');
        var key = tile && tile.getAttribute('data-gf-key');
        if (tile && step.multi) {
          if (key === '__any') { a.t = []; return done('Suggest for me'); }
          tile.classList.toggle('is-on');
          tile.setAttribute('aria-pressed', tile.classList.contains('is-on'));
          a.t = $$('.gf-tile.is-on', holder).map(function (x) { return x.getAttribute('data-gf-key'); }).filter(function (k) { return k !== '__any'; });
          $('[data-gf-next]', holder).disabled = !a.t.length;
          return;
        }
        if (tile) { a[step.id] = key; return done(find(step.type, key).label); }
        if (e.target.closest('[data-gf-skip]')) { a[step.id] = ''; return done('Skip'); }
        if (e.target.closest('[data-gf-next]')) {
          done(a.t.map(function (k) { return find('jewellery', k).label; }).join(', '));
        }
      });
      function done(label) {
        holder.classList.add('is-done');
        holder.remove();
        user(label);
        i++;
        next();
      }
    }
    function finish() {
      var p = find('person', a.p);
      bot('<span class="gf-dots"><i></i><i></i><i></i></span> Looking through our whole collection' + (p && p.key !== 'myself' ? ' for your ' + esc(p.label.replace(/\s*\/.*$/, '')) : '') + '…', 300);
      queue(function () {
        return loadCatalog().then(function (items) {
          var r = rank(items, a);
          var total = r.perfect.length + r.more.length;
          var top = r.perfect.concat(r.more).filter(function (x) { return x.i; }).slice(0, 4);
          var thumbs = top.map(function (x) { return '<img src="' + esc(x.i) + '" alt="' + esc(x.n) + '" loading="lazy" width="64" height="64">'; }).join('');
          if (!total) {
            bot('Hmm, I couldn’t find designs for this exact choice. Try another budget, or ask our team. They love helping with gifts.');
            quick([
              { icon: 'refresh', label: 'Try again', run: function () { giftFlow({ o: a.o }); } },
              { icon: 'whatsapp', label: 'Ask on WhatsApp', run: function () { window.open(waLink('Hi! I am looking for a gift. ' + summary(a).join(' · ')), '_blank'); anythingElse(); } }
            ]);
            return;
          }
          bot('I found <b>' + total + ' beautiful design' + (total === 1 ? '' : 's') + '</b>' +
            (r.perfect.length && r.perfect.length < total ? ', including <b>' + r.perfect.length + ' perfect matches</b>' : '') + '.' +
            (thumbs ? '<span class="sa-thumbs">' + thumbs + '</span>' : ''), 200);
          quick([
            { icon: 'sparkle', label: 'See all ' + total + ' gifts', run: function () { openResults(a); anythingElse(); } },
            { icon: 'refresh', label: 'Start again', run: function () { giftFlow(); } }
          ].concat(C.whatsapp ? [{ icon: 'chat', label: 'Ask an expert', run: function () {
            window.open(waLink('Hi! I am looking for a gift' + (p ? ' for my ' + p.label : '') + '. ' + summary(a).join(' · ') + '. Can you suggest something?'), '_blank');
            anythingElse();
          } }] : []));
        });
      });
    }
    next();
  }

  /* ---------- Order flow ---------- */
  function orderFlow() {
    bot('Let me check that for you…', 300);
    queue(function () {
      return fetch(root + '?section_id=assistant-orders', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('[data-sa-orders]');
          var st = box ? box.getAttribute('data-state') : 'guest';
          if (st === 'list') {
            bot('Here are your latest orders' + (C.firstName ? ', ' + esc(C.firstName) : '') + ':', 250);
            var holder = el('<div class="sa-orders"></div>');
            $$('.sa-order', box).forEach(function (o) { holder.appendChild(document.importNode(o, true)); });
            $$('[data-sa-awb]', holder).forEach(function (a) { a.href = trackLink(a.getAttribute('data-sa-awb')); });
            block(holder);
            bot('<span class="sa-small">The tracking link starts working a few hours after your parcel is shipped.</span>', 300);
            anythingElse();
          } else if (st === 'empty') {
            bot('I couldn’t find any orders on your account' + (box.getAttribute('data-email') ? ' (<b>' + esc(box.getAttribute('data-email')) + '</b>)' : '') + '. If you ordered with a different email or phone, try one of these:');
            guestOptions(true);
          } else {
            bot('For your safety I can only show order details after a quick login with the <b>email or phone you used at checkout</b>. It takes 10 seconds with a one-time code.');
            guestOptions(false);
          }
        })
        .catch(function () {
          bot('Sorry, I couldn’t load your orders right now.');
          guestOptions(!!C.loggedIn);
        });
    });
  }
  function guestOptions(loggedIn) {
    var items = [];
    if (!loggedIn) items.push({ icon: 'lock', label: 'Log in to see my orders', href: C.loginUrl });
    if (C.trackingUrl) items.push({ icon: 'truck', label: 'I have a tracking number', run: askAwb });
    if (C.whatsapp) items.push({ icon: 'receipt', label: 'Ask with my order number', run: askOrderNo });
    items.push({ icon: 'menu', label: 'Main menu', run: function () { menu('What else can I help you with?'); } });
    quick(items);
  }
  function askAwb() {
    bot('Please type your <b>tracking (AWB) number</b>. You’ll find it in the shipping email or SMS.');
    expect('Tracking number, e.g. 1234567890', function (v) {
      var n = v.replace(/[^A-Za-z0-9-]/g, '');
      if (n.length < 6) { bot('That looks too short. Please check the number and try again.'); return askAwb(); }
      var url = trackLink(n);
      bot('Here’s your live tracking:<br><a class="sa-btn sa-btn--primary" href="' + esc(url) + '" target="_blank" rel="noopener">' + icon('truck', 16) + ' Track ' + esc(n) + '</a>');
      anythingElse();
    });
  }
  function askOrderNo() {
    bot('Please type your <b>order number</b> (for example <b>#1023</b>). It’s in your order confirmation email.');
    expect('Order number, e.g. #1023', function (v) {
      var n = v.replace(/[^0-9A-Za-z-]/g, '');
      if (!n) return askOrderNo();
      bot('Thank you! Tap below to send it to our team on WhatsApp. We’ll reply with the latest status.<br><a class="sa-btn sa-btn--wa" href="' +
        esc(waLink('Hi, please share the status of my order #' + n + '.')) + '" target="_blank" rel="noopener">' + icon('whatsapp', 16) + ' Send order #' + esc(n) + '</a>');
      anythingElse();
    });
  }
  function expect(placeholder, fn) {
    queue(function () {
      pendingInput = fn;
      input.placeholder = placeholder;
      input.focus();
    });
  }

  /* ---------- Other flows ---------- */
  function answerFlow(o) {
    var html = o.answer || '';
    if (o.button && o.link) {
      var ext = /^https?:/i.test(o.link) && o.link.indexOf(location.host) < 0;
      html += '<a class="sa-btn sa-btn--primary" href="' + esc(o.link) + '"' + (ext ? ' target="_blank" rel="noopener"' : '') + '>' + esc(o.button) + ' →</a>';
    }
    bot(html);
    anythingElse();
  }
  // Daily display rate (Theme settings → Today's silver rate), never the product pricing rate.
  function dailyRate() { return Number(T.settings.dailyRate) || 0; }
  function rateFlow() {
    var upd = T.settings.dailyRateUpdated ? 'Last updated: ' + esc(T.settings.dailyRateUpdated) + '. ' : '';
    bot('Today’s silver rate is <b>' + rupees(dailyRate()) + ' per gram</b>.<br><span class="sa-small">' + upd + 'GST and making charges are extra.</span>');
    anythingElse();
  }
  function whatsappFlow() {
    bot('Our team is happy to help on WhatsApp.<br><a class="sa-btn sa-btn--wa" href="' + esc(waLink('Hi! I need some help.')) + '" target="_blank" rel="noopener">Open WhatsApp</a>');
    anythingElse();
  }

  /* ---------- Typed questions ---------- */
  var ROUTES = [
    { re: /\b(order|orders|track|tracking|parcel|shipment|shipped|deliver|delivery|delivered|dispatch|awb|courier)\b|kab (tak )?aa?ye|where is my|mera (saman|samaan|parcel)/i, run: function () { orderFlow(); } },
    { re: /\b(gift|gifts|gifting|tohfa|present|surprise)\b/i, run: function () { giftFlow(); } },
    { re: /\b(rate|bhav|bhaav|bhaw)\b|price today|aaj ka/i, run: function () { if (dailyRate() > 0) rateFlow(); else return false; } },
    { re: /\b(whatsapp|call|talk|human|agent|baat|contact|phone|number)\b/i, run: function () { whatsappFlow(); } }
  ];
  function route(text) {
    var t = text.toLowerCase();
    for (var i = 0; i < ROUTES.length; i++) {
      if (ROUTES[i].re.test(t) && ROUTES[i].run() !== false) return;
    }
    for (var j = 0; j < OPT.answer.length; j++) {
      var keys = list(OPT.answer[j].keywords);
      for (var k = 0; k < keys.length; k++) {
        if (t.indexOf(keys[k]) > -1) return answerFlow(OPT.answer[j]);
      }
    }
    if (/^(hi|hii+|hello|hey|namaste|namaskar)\b/i.test(t)) return menu('Namaste! How can I help you today?');
    search(text);
  }
  function search(text) {
    bot('Let me look for “' + esc(text) + '” in our collection…', 300);
    queue(function () {
      var url = root + 'search/suggest?q=' + encodeURIComponent(text) + '&resources[type]=product&resources[limit]=4&section_id=predictive-search';
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var prods = doc.querySelector('.predictive__products');
        if (prods && prods.children.length) {
          bot('Here’s what I found:', 150);
          block('<div class="sa-products">' + prods.outerHTML + '<a class="sa-link" href="' + esc((T.routes.search || '/search') + '?q=' + encodeURIComponent(text) + '&type=product') + '">See all results →</a></div>');
        } else {
          bot('I couldn’t find that, sorry. Our team will be happy to help.');
        }
        quick(menuItems().slice(0, 2).concat([
          { icon: 'menu', label: 'Main menu', run: function () { menu(); } }
        ]).concat(C.whatsapp ? [{ icon: 'whatsapp', label: 'Talk to our team', run: whatsappFlow }] : []));
      }).catch(function () { menu(); });
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (!v) return;
      input.value = '';
      if (gate) { bot('Please share your name and mobile number above to continue.'); return; }
      user(v);
      if (pendingInput) {
        var fn = pendingInput;
        pendingInput = null;
        input.placeholder = input.getAttribute('data-placeholder') || input.placeholder;
        fn(v);
        return;
      }
      route(v);
    });
    input.setAttribute('data-placeholder', input.placeholder);
  }
  if (body) {
    body.addEventListener('click', function (e) {
      var w = e.target.closest('[data-sa-wa-order]');
      if (w) window.open(waLink('Hi, please share the status of my order ' + w.getAttribute('data-sa-wa-order') + '.'), '_blank');
    });
  }

  /* ---------- Open / close ---------- */
  function openPanel(mode, opt) {
    if (!panel) {
      if (mode === 'gift') location.href = C.giftPageUrl || '/';
      return;
    }
    opt = opt || {};
    hideNudge();
    panel.hidden = false;
    wrap.classList.add('is-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('sa-open');
    if (opt.restart) reset();
    var run = function () {
      if (mode === 'gift') giftFlow(opt.preset);
      else if (mode === 'order') orderFlow();
    };
    if (!started) {
      if (mode) {
        started = true;
        bot(esc((C.greeting || 'Namaste!').split('\n')[0]), 250);
        withDetails(run);
      } else greet();
    } else if (gate) {
      bot('Please share your name and mobile number above to continue.');
    } else run();
    setTimeout(function () { if (window.matchMedia('(min-width: 750px)').matches) input.focus(); }, 300);
  }
  function closePanel() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    wrap.classList.remove('is-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('sa-open');
  }
  function reset() {
    gate = false;
    body.innerHTML = '';
    chain = Promise.resolve();
    pendingInput = null;
    started = false;
  }

  if (wrap) {
    toggleBtn.addEventListener('click', function () { panel.hidden ? openPanel() : closePanel(); });
    $('[data-sa-close]', panel).addEventListener('click', closePanel);
    $('[data-sa-restart]', panel).addEventListener('click', function () { reset(); greet(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (overlay && !overlay.hidden) closeResults(); else closePanel();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sa-open]');
    if (t) {
      if (!panel) return; // assistant switched off: follow the link
      e.preventDefault();
      var preset = t.getAttribute('data-gf-occasion') ? { o: t.getAttribute('data-gf-occasion') } : null;
      openPanel(t.getAttribute('data-sa-open') || '', { restart: !!preset || t.getAttribute('data-sa-open') === 'gift', preset: preset });
      return;
    }
    var h = e.target.closest('a[href*="#gift-finder"], a[href*="#where-is-my-order"], a[href*="#assistant"]');
    if (h && h.pathname === location.pathname) {
      e.preventDefault();
      var hash = h.hash;
      openPanel(hash === '#gift-finder' ? 'gift' : hash === '#where-is-my-order' ? 'order' : '', { restart: hash !== '#assistant' });
    }
  });

  /* ---------- Hint bubble next to the button (once per visit) ---------- */
  var nudge = wrap && $('[data-sa-nudge]', wrap);
  function hideNudge() { if (nudge) nudge.hidden = true; }
  if (nudge) {
    var seen = false;
    try { seen = sessionStorage.getItem('stj_sa_nudge') === '1'; } catch (e) {}
    if (!seen) {
      setTimeout(function () {
        if (!panel.hidden || document.body.classList.contains('is-locked')) return;
        var popupNow = document.querySelector('[data-welcome-popup]:not([hidden])'), popupShown = false;
        try { popupShown = sessionStorage.getItem('stj_popup_shown') === '1'; } catch (e) {}
        if (popupNow || popupShown) return; // one invitation at a time
        nudge.hidden = false;
        try { sessionStorage.setItem('stj_sa_nudge', '1'); } catch (e) {}
        var hideAfter = Number(nudge.getAttribute('data-hide') || 6);
        if (hideAfter > 0) setTimeout(hideNudge, hideAfter * 1000);
      }, (Number(nudge.getAttribute('data-delay')) || 8) * 1000);
    }
    $('[data-sa-nudge-close]', nudge).addEventListener('click', hideNudge);
  }

  /* ==========================================================================
     Gift Finder page (sections/gift-finder-page.liquid)
     ========================================================================== */
  $$('[data-gf-page]').forEach(function (page) {
    var quiz = $('[data-gf-quiz]', page);
    var results = $('[data-gf-results]', page);
    var intro = $('[data-gf-intro]', page);
    var a = { t: [] };
    var i = 0;

    function show(n) {
      i = n;
      while (i < STEPS.length && STEPS[i].id === 'o' && a._presetO) i++;
      if (i >= STEPS.length) return page._showResults(a);
      var step = STEPS[i];
      var pct = Math.round((i / STEPS.length) * 100);
      quiz.hidden = false;
      results.hidden = true;
      quiz.innerHTML =
        '<div class="gfq">' +
          '<div class="gfq__top"><span class="gfq__count">Step ' + (i + 1) + ' of ' + STEPS.length + '</span>' +
          '<span class="gfq__bar"><span style="width:' + Math.max(pct, 6) + '%"></span></span></div>' +
          '<h2 class="gfq__q">' + esc(step.q) + '</h2>' +
          (step.multi ? '<p class="gfq__hint">Choose one or more</p>' : '') +
          tilesHtml(step, a, 'gf-tiles--page') +
          '<div class="gfq__nav">' +
            (i > 0 ? '<button type="button" class="gfq__back" data-gfq-back>← Back</button>' : '<span></span>') +
            '<span class="gfq__right">' +
              (step.skip ? '<button type="button" class="gfq__skip" data-gfq-skip>Skip</button>' : '') +
              (step.multi ? '<button type="button" class="btn" data-gfq-next' + (a.t.length ? '' : ' disabled') + '>Continue →</button>' : '') +
            '</span>' +
          '</div>' +
        '</div>';
      var qEl = $('.gfq', quiz);
      qEl.classList.add('gfq--in');
      if (n > 0 && quiz.getBoundingClientRect().top < 0) quiz.scrollIntoView({ block: 'start', behavior: 'smooth' });

      quiz.onclick = function (e) {
        var tile = e.target.closest('[data-gf-key]');
        if (tile) {
          var key = tile.getAttribute('data-gf-key');
          if (step.multi) {
            if (key === '__any') { a.t = []; return show(i + 1); }
            var k = a.t.indexOf(key);
            if (k > -1) a.t.splice(k, 1); else a.t.push(key);
            tile.classList.toggle('is-on', k < 0);
            tile.setAttribute('aria-pressed', k < 0);
            $('[data-gfq-next]', quiz).disabled = !a.t.length;
            return;
          }
          a[step.id] = key;
          $$('.gf-tile', quiz).forEach(function (t) { t.classList.toggle('is-on', t === tile); });
          setTimeout(function () { show(i + 1); }, 180);
          return;
        }
        if (e.target.closest('[data-gfq-skip]')) { a[step.id] = ''; return show(i + 1); }
        if (e.target.closest('[data-gfq-next]')) return show(i + 1);
        if (e.target.closest('[data-gfq-back]')) {
          var prev = i - 1;
          while (prev > 0 && STEPS[prev].id === 'o' && a._presetO) prev--;
          show(Math.max(prev, 0));
        }
      };
    }

    page._showResults = function (ans, quiet) {
      a = ans;
      quiz.hidden = true;
      if (intro) intro.hidden = true;
      results.hidden = false;
      renderResults(results, ans, {
        updateUrl: true,
        onRestart: function (cur) {
          a = { t: [], o: page.getAttribute('data-preset-occasion') ? cur.o : '' };
          a._presetO = !!page.getAttribute('data-preset-occasion');
          if (intro) intro.hidden = false;
          show(0);
        }
      });
      if (!quiet) page.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    var preset = page.getAttribute('data-preset-occasion');
    if (preset && find('occasion', preset)) { a.o = preset; a._presetO = true; }
    var fromUrl = new URLSearchParams(location.search).get('gf');
    if (fromUrl) {
      var dec = decode(fromUrl);
      if (dec.p || dec.b) { page._showResults(dec, true); return; }
    }
    show(0);
  });

  /* ---------- Shared link opened on another page (?gf=...) ---------- */
  (function () {
    if ($('[data-gf-page]')) return;
    var p = new URLSearchParams(location.search).get('gf');
    if (p) {
      var dec = decode(p);
      if (dec.p || dec.b) openResults(dec);
    }
    if (location.hash === '#gift-finder') openPanel('gift');
    else if (location.hash === '#where-is-my-order') openPanel('order');
  })();

  // Load the catalog as soon as the customer shows interest, so results feel instant
  if (toggleBtn && C.showGift) {
    var warm = function () { loadCatalog(); };
    toggleBtn.addEventListener('pointerenter', warm, { once: true });
    toggleBtn.addEventListener('focus', warm, { once: true });
  }
  $$('[data-sa-open="gift"]').forEach(function (b) { b.addEventListener('pointerenter', function () { loadCatalog(); }, { once: true }); });
  if ($('[data-gf-page]')) loadCatalog();

  window.STJAssistant = { open: openPanel, close: closePanel, openResults: openResults };
})();
